import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "display",
    "edit",
    "titleInput",
    "titleText",
    "hostedForText",
    "partyStartText",
    "partyEndText",
    "partyAddressText"
  ]
  static values = { editing: Boolean }

  connect() {
    this.sync()
  }

  beginEdit() {
    this.editingValue = true
    this.sync()
    this.titleInputTarget?.focus()
    this.titleInputTarget?.select()
  }

  cancelEdit() {
    const form = this.element.querySelector("#admin-party-edit-form")
    if (form) {
      form.reset()
      Array.from(form.elements).forEach((field) => {
        if (field._flatpickr) field._flatpickr.setDate(field.defaultValue, false)
      })
    }

    this.editingValue = false
    this.sync()
  }

  editingValueChanged() {
    this.sync()
  }

  async save(event) {
    event.preventDefault()
    event.stopPropagation()

    const form = event.currentTarget
    if (!form.reportValidity()) return

    const submitButton = this.element.querySelector('[type="submit"][form="admin-party-edit-form"]')
    if (submitButton) submitButton.disabled = true

    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: new FormData(form),
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        }
      })
      const payload = await response.json()

      if (!response.ok) throw new Error(payload.error || "Party profile could not be updated.")

      this.applySavedValues(payload.party)
      this.editingValue = false
      this.sync()
      this.showToast(payload.message || "Party profile updated.", "notice")
    } catch (error) {
      this.showToast(error.message || "Party profile could not be updated.", "alert")
    } finally {
      if (submitButton) submitButton.disabled = false
    }
  }

  sync() {
    if (!this.hasDisplayTarget || !this.hasEditTarget) return

    this.displayTargets.forEach((element) => {
      element.classList.toggle("is-hidden", this.editingValue)
    })
    this.editTargets.forEach((element) => {
      element.classList.toggle("is-hidden", !this.editingValue)
    })

    if (!this.editingValue) {
      const form = this.element.querySelector("#admin-party-edit-form")
      Array.from(form?.elements || []).forEach((field) => field._flatpickr?.close())
    }
  }

  applySavedValues(party) {
    if (!party) return

    this.titleTextTarget.textContent = party.display.title
    this.hostedForTextTarget.textContent = party.display.hosted_for
    this.partyStartTextTarget.textContent = party.display.party_start
    this.partyEndTextTarget.textContent = party.display.party_end
    this.partyAddressTextTarget.textContent = party.display.party_address

    const form = this.element.querySelector("#admin-party-edit-form")
    Object.entries(party.edit).forEach(([fieldName, value]) => {
      const field = form?.elements.namedItem(`party_profile[${fieldName}]`)
      if (!field) return

      field.defaultValue = value || ""
      if (field._flatpickr) {
        field._flatpickr.setDate(value || "", false)
      } else {
        field.value = value || ""
      }
    })
  }

  showToast(message, type) {
    const flash = document.createElement("div")
    flash.dataset.controller = "flash"
    flash.dataset.flashNoticeValue = type === "notice" ? message : ""
    flash.dataset.flashAlertValue = type === "alert" ? message : ""
    document.body.appendChild(flash)

    window.setTimeout(() => flash.remove(), 200)
  }
}
